const StripeCard = require("components/abstract/StripeCard");
const Field = require("components/forms/Field");
const {pluckKeysExcept} = require("helpers/object");
const {classList} = require("helpers/html");
const assign = require("object-assign");
const PropTypes = require("prop-types");

class CreditCard extends StripeCard {

	static get propTypes() {
		return assign(super.propTypes, {
			currentCardType: PropTypes.any,
			currentCardDigits: PropTypes.any
		});
	}

	get className() {
		return classList(
			"credit-card-field",
			this.props.className
		);
	}

	get inputProps() {
		return pluckKeysExcept(this.props, Object.keys(this.constructor.propTypes).concat(["error"]));
	}

	renderCurrentCard() {
		const {currentCardType, currentCardDigits} = this.props;

		if (typeof currentCardType === "string" && typeof currentCardDigits === "string") {
			return (
				<div className="current-card">
					<span>{currentCardType}</span>
					<span>XXXX XXXX XXXX {currentCardDigits}</span>
				</div>
			);
		}
	}

	render() {
		return (
			<Field required={this.props.required} error={this.state.error} {...this.inputProps}>
				{this.renderCurrentCard()}
				{this.renderBody()}
				{this.renderToken()}
			</Field>
		);
	}

}

module.exports = CreditCard;


// WEBPACK FOOTER //
// ./resources/js/components/forms/CreditCard.js